import Link from 'next/link'
import { COMPANY } from '@/lib/company'

const FACTS: { label: string; value: React.ReactNode }[] = [
  {
    label: 'What it is',
    value:
      'An all-in-one CRM and operating system for contractors: CRM, unified inbox, estimating, proposals and e-signature, scheduling, invoicing and marketing automation in one platform.',
  },
  {
    label: 'Who it is for',
    value: 'Roofing contractors first, plus siding, gutter, solar and remodeling companies.',
  },
  {
    label: 'Pricing',
    value: (
      <>
        Starter is ${COMPANY.plans[0].price}/month and Pro is ${COMPANY.plans[1].price}/month. Every plan includes
        unlimited users, with no per-seat fees and no contracts.{' '}
        <Link href="/pricing" className="text-red-400 hover:text-red-300 underline">
          See plans
        </Link>
        .
      </>
    ),
  },
  {
    label: 'What Pro adds',
    value:
      'Storm Intelligence and canvassing, the Sierra AI chat and SMS agent, an AI Voice Agent, AI proposal drafting and MCP access, with 10,000 AI credits and 500 AI voice minutes each month.',
  },
  {
    label: 'Integrations',
    value: (
      <>
        EagleView, QuickBooks, Twilio, Google Workspace, NOAA Weather, ABC Supply and SRS Distribution.{' '}
        <Link href="/integrations" className="text-red-400 hover:text-red-300 underline">
          All integrations
        </Link>
        .
      </>
    ),
  },
  {
    label: 'Company',
    value: `${COMPANY.legalName}, founded ${COMPANY.founded} and generally available since ${COMPANY.launched}. Headquartered in ${COMPANY.address.city}, ${COMPANY.address.region}. CEO: ${COMPANY.ceo}.`,
  },
]

/** Plain, server-rendered facts so search engines and AI assistants can quote BuilderLync accurately. */
export function AtAGlance() {
  return (
    <section className="section" aria-labelledby="at-a-glance">
      <div className="section-inner max-w-4xl">
        <h2 id="at-a-glance" className="text-2xl sm:text-3xl font-bold text-center mb-8">
          BuilderLync <span className="gradient-text-red">at a Glance</span>
        </h2>
        <dl className="glass-card-premium divide-y divide-zinc-800/60">
          {FACTS.map((fact) => (
            <div key={fact.label} className="grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-1 sm:gap-6 p-5">
              <dt className="text-sm font-semibold text-white">{fact.label}</dt>
              <dd className="text-sm text-zinc-400 leading-relaxed">{fact.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
